function updateLiveBrandConfig(design_identifier, brand_configuration) {
  return fetch(`${process.env.REACT_APP_API_ENDPOINT}/brand-configuration`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      design_identifier: design_identifier,
      brand_configuration: brand_configuration,
    },
  })
    .then((response) => response.json())
    .then((responseJSON) => {
      return responseJSON;
    });
}

export default updateLiveBrandConfig;
